import { mask as applyVueTheMask } from 'vue-the-mask';

/**
 * vue-the-mask throws when binding.value is null/undefined and can clear inputs
 * when mask is empty. Skip binding when no mask pattern is configured.
 */
export const safeMask = {
  bind(el, binding) {
    if (!binding.value) return;
    applyVueTheMask(el, binding);
  },
};
